module.exports = __webpack_public_path__ + "static/media/commitm.09ba531a.jpg";